import React, {useContext} from "react"

export const DisableFormElementsContext = React.createContext<boolean>(false)

export const useDisableFormElementCtx = () => useContext(DisableFormElementsContext)
